module.exports = __webpack_public_path__ + "img/pr-4.43f54e89.png";